<template>
  <div class="judging-fast-start">
    <div class="row">
      <div class="col-xs-12 col-lg-6">
        <steps
          v-model="step"
          :steps="availableSteps"
          :completed-steps="completedSteps"
          :locked="fastStartFinished"
        />
      </div>
    </div>
    <mode
      v-if="step === 'mode'"
      :all-modes="allModes"
      :vip-judging-score-sets="vipJudgingScoreSets"
      :available-modes="availableModes"
      :voting-score-set-template="votingScoreSetTemplate"
      :top-pick-score-set-template="topPickScoreSetTemplate"
      :gallery-score-set-template="galleryScoreSetTemplate"
      @modeSelected="mode => (currentMode = mode)"
      @next="onNext"
      @back="onBack"
      @toStep="toStep"
    />
    <scoring
      v-if="step === 'scoring' && currentMode === 'vip_judging'"
      :scoring-criterion-template="scoringCriterionTemplate"
      :routes="routes"
      :language="language"
      @next="onNext"
      @back="onBack"
    />
    <voting
      v-if="step === 'scoring' && currentMode === 'voting'"
      @next="onNext"
      @back="onBack"
    />
    <top-pick
      v-if="step === 'scoring' && currentMode === 'top_pick'"
      @next="onNext"
      @back="onBack"
    />
    <entries
      v-if="step === 'entries'"
      :categories="categories"
      :chapters="chapters"
      :tags="tags"
      @next="onNext"
      @back="onBack"
    />
    <judges
      v-if="step === 'judges'"
      :roles="roles"
      :judging-mode="currentMode"
      :judge-selector-url="judgeSelectorUrl"
      :language="language"
      :default-language="defaultLanguage"
      :translations="translations"
      @next="onNext"
      @back="onBack"
    />
    <rounds
      v-if="step === 'rounds'"
      :round-template="roundTemplate"
      :routes="routes"
      @next="onNext"
      @back="onBack"
    />
    <complete
      v-if="step === 'complete'"
      :season="season"
      :routes="routes"
      @finish="onFinish"
    />
  </div>
</template>

<script>
import langMixin from '@/lib/components/Translations/mixins/lang-mixin.js';
import Steps from '@/lib/components/Shared/Steps';
import Mode from './Mode/Mode';
import Scoring from './Scoring/Scoring';
import Voting from './Scoring/Voting';
import TopPick from './Scoring/TopPick';
import Entries from './Entries/Entries';
import Judges from './Judges/Judges';
import Rounds from './Rounds/Rounds';
import Complete from './Complete/Complete';

export default {
  components: {
    Steps,
    Mode,
    Scoring,
    Voting,
    TopPick,
    Entries,
    Judges,
    Rounds,
    Complete
  },
  mixins: [langMixin],
  props: {
    steps: {
      type: Array,
      default: () => []
    },
    allModes: {
      type: Array,
      default: () => []
    },
    availableModes: {
      type: Array,
      default: () => []
    },
    vipJudgingScoreSets: {
      type: Array,
      default: () => []
    },
    season: {
      type: Object,
      required: true
    },
    categories: {
      type: Array,
      default: () => []
    },
    chapters: {
      type: Array,
      default: () => []
    },
    tags: {
      type: Array,
      default: () => []
    },
    roles: {
      type: Array,
      default: () => []
    },
    rounds: {
      type: Array,
      default: () => []
    },
    judgeSelectorUrl: {
      type: String,
      required: true
    },
    votingScoreSetTemplate: {
      type: Object,
      default: () => ({})
    },
    topPickScoreSetTemplate: {
      type: Object,
      default: () => ({})
    },
    galleryScoreSetTemplate: {
      type: Object,
      default: () => ({})
    },
    scoringCriterionTemplate: {
      type: Object,
      default: () => ({})
    },
    roundTemplate: {
      type: Object,
      default: () => ({})
    },
    routes: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      step: 'mode',
      completedSteps: ['mode'],
      currentMode: null,
      fastStartFinished: false
    };
  },
  computed: {
    availableSteps() {
      // Qualifying and gallery modes do not have step 2 (scoring)
      if (this.currentMode === 'qualifying' || this.currentMode === 'gallery') {
        return this.steps.filter(step => step.id !== 'scoring');
      }

      return this.steps;
    },
    stepIndex() {
      return this.availableSteps.findIndex(step => step.id === this.step);
    }
  },
  beforeCreate() {
    // Reset vuex store modules to default state
    this.$store.commit('judgingFastStart/resetState');
  },
  created() {
    this.$store.commit('judgingFastStart/storeRounds', this.rounds);
  },
  methods: {
    onNext() {
      this.toStep(this.findStep(this.stepIndex + 1));
    },
    onBack() {
      this.toStep(this.findStep(this.stepIndex - 1), false);
    },
    onFinish() {
      this.fastStartFinished = true;
    },
    findStep(index) {
      return (this.availableSteps[index] || {}).id;
    },
    toStep(stepId, markCompleted = true) {
      // Return early
      if (!stepId) {
        return;
      }

      // Progress to the next step
      this.step = stepId;

      // All previous steps are now completed
      if (markCompleted) {
        this.completedSteps = this.steps
          .filter(
            (step, i) => i <= this.steps.findIndex(step => step.id === stepId)
          )
          .map(step => step.id);
      }
    }
  }
};
</script>
